import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

import { useMobile } from '../../../../hooks/useMobile';

export const TimeframeStep = ({ startDate, endDate, onChange }) => {
  const isMobile = useMobile();

  const range = {
    from: startDate ? new Date(startDate) : undefined,
    to: endDate ? new Date(endDate) : undefined
  };

  const handleSelect = (selected) => {
    onChange({
      startDate: selected?.from ? toIsoDate(selected.from) : null,
      endDate: selected?.to ? toIsoDate(selected.to) : null
    });
  };

  return (
    <div className="meal-planner-step">
      <h2 className="meal-planner-step__title">Choose your dates</h2>
      <p className="meal-planner-step__sub">Pick the start and end date for your meal plan.</p>
      <div className="meal-planner-step__daypicker">
        <DayPicker
          mode="range"
          numberOfMonths={isMobile ? 1 : 2}
          selected={range}
          onSelect={handleSelect}
          disabled={{ before: new Date() }}
        />
      </div>
      {startDate && endDate && (
        <div className="meal-planner-step__range-summary">
          {startDate} &rarr; {endDate} ({daysBetween(startDate, endDate)} days)
        </div>
      )}
    </div>
  );
};

const toIsoDate = (date) => {
  const offset = date.getTimezoneOffset();
  const adjusted = new Date(date.getTime() - offset * 60 * 1000);
  return adjusted.toISOString().slice(0, 10);
};

const daysBetween = (start, end) =>
  Math.round((new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24)) + 1;
